import { render, staticRenderFns } from "./TableSorting.vue?vue&type=template&id=11171042&scoped=true&"
import script from "./TableSorting.vue?vue&type=script&lang=js&"
export * from "./TableSorting.vue?vue&type=script&lang=js&"
import style0 from "./TableSorting.vue?vue&type=style&index=0&id=11171042&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11171042",
  null
  
)

export default component.exports